/* eslint-disable sort-keys */
export const urls: Record<
  'fr-en',
  Record<string, '/l/fr/en' | `/l/fr/en/${string}`>
> = {
  'fr-en': {
    // Home
    '': '/l/fr/en/home',

    // Alumni
    alumni: '/l/fr/en/alumni',

    // B2B
    enterprise: '/l/fr/en/b2b',
    'enterprise/contact': '/l/fr/en/b2b/apply',

    // Campus
    paris: '/l/fr/en/campus/par',
    remote: '/l/fr/en/campus/rmt',

    // Career
    career: '/l/fr/en/career',

    // Courses
    'web-development': '/l/fr/en/course/wd',
    'data-analytics': '/l/fr/en/course/da',
    'ux-ui-design': '/l/fr/en/course/ux',
    cybersecurity: '/l/fr/en/course/cy',

    // FAQ
    faq: '/l/fr/en/faq',

    // Financing Options
    'financing-options': '/l/fr/en/financing',

    // Forms
    apply: '/l/fr/en/apply',
    apply2: '/l/fr/en/full-apply',
    contact: '/l/fr/en/contact',
    'financing-form': '/l/fr/en/financing-form',
    'thank-you': '/l/fr/en/thank-you',

    // Quiz
    quiz: '/l/fr/en/quiz',
    'artificial-intelligence/match': '/l/fr/en/quiz-match/ai',
    'cybersecurity/match': '/l/fr/en/quiz-match/cy',
    'data-analytics/match': '/l/fr/en/quiz-match/da',
    'devops-cloud-computing/match': '/l/fr/en/quiz-match/dv',
    'digital-marketing/match': '/l/fr/en/quiz-match/mk',
    'data-science-machine-learning/match': '/l/fr/en/quiz-match/ml',
    'ux-ui-design/match': '/l/fr/en/quiz-match/ux',
    'web-development/match': '/l/fr/en/quiz-match/wd',

    // Syllabus Forms
    'ai-consulting-integration/syllabus': '/l/fr/en/syllabus/ac',
    'artificial-intelligence/syllabus': '/l/fr/en/syllabus/ai',
    'cloud-engineer/syllabus': '/l/fr/en/syllabus/ce',
    'cybersecurity/syllabus': '/l/fr/en/syllabus/cy',
    'data-analytics/syllabus': '/l/fr/en/syllabus/da',
    'data-engineering/syllabus': '/l/fr/en/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/fr/en/syllabus/dv',
    'digital-marketing/syllabus': '/l/fr/en/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/fr/en/syllabus/ml',
    'ai-product-manager/syllabus': '/l/fr/en/syllabus/pm',
    'ux-ui-design/syllabus': '/l/fr/en/syllabus/ux',
    'web-development/syllabus': '/l/fr/en/syllabus/wd',

    // PDP
    'ai-consulting-integration/remote': '/l/fr/en/pdp/ac/rmt',
    'artificial-intelligence/remote': '/l/fr/en/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/fr/en/pdp/ce/rmt',
    'data-engineering/remote': '/l/fr/en/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/fr/en/pdp/dv/rmt',
    'digital-marketing/remote': '/l/fr/en/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/fr/en/pdp/ml/rmt',
    'ai-product-manager/remote': '/l/fr/en/pdp/pm/rmt',
  },
};
/* eslint-enable sort-keys */
